export default __webpack_public_path__ + "static/media/gallery_01.e42b200c.jpg";